import React from 'react';
import Switch from 'react-switch';
import { Label, PitchTypeToggleWrapper } from './PitchTypeToggleStyles';

interface IProps {
  isManualPitchType: boolean;
  isManualPitchTypeCallback: (checked: boolean) => void;
  disabled: boolean;
}

export const PitchTypeToggle: React.FC<IProps> = (props) => {
  const { isManualPitchType, isManualPitchTypeCallback, disabled } = props;
  return (
    <PitchTypeToggleWrapper>
      <Label>Pitch type</Label>
      <Switch
        checked={isManualPitchType}
        onChange={(checked: boolean) => isManualPitchTypeCallback(checked)}
        onColor='#ec691a'
        checkedIcon={false}
        uncheckedIcon={false}
        height={24.8}
        width={40.8}
        disabled={disabled}
      />
    </PitchTypeToggleWrapper>
  );
};
